import React, { useState, useEffect } from "react";
import {
  Button,
  Popover,
  OverlayTrigger,
  Accordion,
  Tooltip,
} from "react-bootstrap";

const AgendaAccordianHeader = (props) => {
  const { agenda, index, minutesCount } = props;
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const tooltip = (attendee) => {
    return (
      <Tooltip id="tooltip">
        {attendee.name} / {attendee?.email}
      </Tooltip>
    );
  };
  const popoverHoverFocus = (title) => {
    return (
      <Popover id="popover-basic" className="custom-popover">
        <Popover.Body className="popover-body">{title}</Popover.Body>
      </Popover>
    );
  };

  return (
    <Accordion.Header>
      <div className="d-flex justify-content-between w-100">
        <div className="d-flex justify-content-between">
          {screenSize >= 360 && screenSize < 550 ? (
            <>
              {(() => {
                // Calculate slice length dynamically
                const baseLength = 31; // You can tweak this multiplier
                const sliceLength = Math.floor(screenSize / baseLength);

                const shortTitle =
                  agenda?.title.length > sliceLength
                    ? agenda?.title.slice(0, sliceLength) + "..."
                    : agenda?.title;

                return (
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={popoverHoverFocus(agenda?.title)}
                  >
                    <span className="pre-wrap-text">
                      {`Agenda ${index + 1}: ${shortTitle}`}
                    </span>
                  </OverlayTrigger>
                );
              })()}
            </>
          ) : screenSize > 550 && screenSize < 1199 ? (
            <>
              {(() => {
                // Calculate slice length dynamically
                const baseLength = 16; // You can tweak this multiplier
                const sliceLength = Math.floor(screenSize / baseLength);

                const shortTitle =
                  agenda.title.length > sliceLength
                    ? agenda.title.slice(0, sliceLength) + "..."
                    : agenda.title;

                return (
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={popoverHoverFocus(agenda.title)}
                  >
                    <span className="pre-wrap-text">
                      {`Agenda ${index + 1}: ${shortTitle}`}
                    </span>
                  </OverlayTrigger>
                );
              })()}
            </>
          ) : screenSize > 1199 && screenSize < 1400 ? (
            <>
              {(() => {
                // Calculate slice length dynamically
                const baseLength = 42; // You can tweak this multiplier
                const sliceLength = Math.floor(screenSize / baseLength);

                const shortTitle =
                  agenda.title.length > sliceLength
                    ? agenda.title.slice(0, sliceLength) + "..."
                    : agenda.title;

                return (
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={popoverHoverFocus(agenda.title)}
                  >
                    <span className="pre-wrap-text">
                      {`Agenda ${index + 1}: ${shortTitle}`}
                    </span>
                  </OverlayTrigger>
                );
              })()}
            </>
          ) : screenSize >= 1400 && screenSize < 1700 ? (
            <>
              {(() => {
                // Calculate slice length dynamically
                const baseLength = 34; // You can tweak this multiplier
                const sliceLength = Math.floor(screenSize / baseLength);

                const shortTitle =
                  agenda.title.length > sliceLength
                    ? agenda.title.slice(0, sliceLength) + "..."
                    : agenda.title;

                return (
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={popoverHoverFocus(agenda.title)}
                  >
                    <span className="pre-wrap-text">
                      {`Agenda ${index + 1}: ${shortTitle}`}
                    </span>
                  </OverlayTrigger>
                );
              })()}
            </>
          ) : (
            <>
              {(() => {
                // Calculate slice length dynamically
                const baseLength = 25; // You can tweak this multiplier
                const sliceLength = Math.floor(screenSize / baseLength);

                const shortTitle =
                  agenda.title.length > sliceLength
                    ? agenda.title.slice(0, sliceLength) + "..."
                    : agenda.title;

                return (
                  <OverlayTrigger
                    trigger={["hover", "focus"]}
                    placement="top"
                    overlay={popoverHoverFocus(agenda.title)}
                  >
                    <span className="pre-wrap-text">
                      {`Agenda ${index + 1}: ${shortTitle}`}
                    </span>
                  </OverlayTrigger>
                );
              })()}
            </>
          )}
        </div>
        {minutesCount ? (
          <div>
            <span className="agenda-span badge">{minutesCount}</span>
          </div>
        ) : null}
      </div>
    </Accordion.Header>
  );
};

export default AgendaAccordianHeader;
